import {
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithChildren,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import MuiCircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

export type Props = {
  loading: boolean;
  size?: number;
  center?: boolean;
} & PropsWithChildren;

export const CircularProgress: FR<HTMLDivElement, Props> = forwardRef((props: Props, ref) => {
  const { children, loading, size = 40, center = true } = props;

  if (loading && center)
    return (
      <Box
        ref={ref}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          minHeight: '200px',
        }}
      >
        <MuiCircularProgress size={size} />
      </Box>
    );
  if (loading && !center)
    return (
      <Box ref={ref}>
        <MuiCircularProgress size={size} />
      </Box>
    );

  return <>{children}</>;
});
